/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuCrossOwnerDocsRequestSynchronizationDataCreateRequest = {} | null | undefined;
export type SvuCrossOwnerDocsRequestSynchronizationDataCreateResponse = any;

export type SvuCrossOwnerDocsRequestSynchronizationDataCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/request_synchronization_data/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_request_synchronization_data_create
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsRequestSynchronizationDataCreateOperation = ({
  id,
  ...rest
}: SvuCrossOwnerDocsRequestSynchronizationDataCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/svu_cross_owner_docs/${id}/request_synchronization_data/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & {
      _templateUrl: '/dmx-server/svu_cross_owner_docs/{id}/request_synchronization_data/';
    };
  };

/**
 * POST /dmx-server/svu_cross_owner_docs/{id}/request_synchronization_data/
 *
 * ```yaml
 * operationId: svu_cross_owner_docs_request_synchronization_data_create
 * tags:
 *   - svu_cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuCrossOwnerDocsRequestSynchronizationDataCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuCrossOwnerDocsRequestSynchronizationDataCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuCrossOwnerDocsRequestSynchronizationDataCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
